<template style="position: relative;">
    <div>
        <img src="@/assets/img/BG.png" alt="" class="bg">
        <div class="login-item">
            <div class="logo-title">
                <img src="@/assets/img/logo.png" class="logo" alt="">
                <div>- 授权管理系统 -</div>
            </div>
            <div class="login">
                <div class="title">
                    <div class="title-text active">登录</div>
                    <div></div>
                </div>
                <!--<div class="title">
                    <router-link to="/passport/register" class="title-text">注册</router-link>
                    <div></div>
                </div>-->
                <el-form :model="form" :rules="rules" ref="form" @keyup.enter.native="submit('form')">
                    <el-form-item prop="mobile">
                        <el-input v-model="form.mobile" placeholder="请输入手机号"/>
                    </el-form-item>
                    <el-form-item prop="password">
                        <el-input v-model="form.password" type="password" placeholder="请输入密码"/>
                    </el-form-item>
                    <el-form-item prop="captcha">
                        <div flex="dir:left">
                            <div>
                                <el-input v-model="form.captcha" placeholder="请输入验证码"/>
                            </div>
                            <div style="padding-left: 10px">
                                <img v-if="captchaUrl" :src="captchaUrl" @click="reloadCaptcha()"
                                     style="height: 40px;width: auto;cursor: pointer;">
                            </div>
                        </div>
                    </el-form-item>
                    <el-form-item>
                        <el-button :loading="loading" type="primary" @click="submit('form')">登录</el-button>
                    </el-form-item>
                </el-form>
                <div class="forget">
                    <router-link to="/passport/reset-password">忘记密码？</router-link>
                </div>
            </div>
        </div>
        <!--<div class="foot-msg">Powered by 禾匠信息科技</div>-->
    </div>
</template>

<style scoped>
.bg{
    width: 100%;
}

.login-item{
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
}

.logo-title{
    width: 190px;
    padding-top: 120px;
    margin: 0 auto 32px;
    font-size: 18px;
    color: #fff;
    text-align: center;
}

.logo-title .logo{
    height: 40px;
    width: 190px;
    margin-bottom: 10px;
}

.login {
    width: 280px;
    height: 310px;
    margin: 0 auto;
    padding: 45px;
    padding-left: 55px;
    border-radius: 20px;
    text-align: center;
    background-color: #fff;
}

.title {
    width: 50%;
    display: inline-block;
    text-align: center;
    margin-bottom: 38px;
    display: inline-block;
}

.title-text {
    font-size: 18px;
    color: #1E4780;
}

.title .active {
    margin-bottom: 8px;
    color: #2E9FFF;
}

.active+div {
    height: 4px;
    width: 22px;
    background-color: #2E9FFF;
    margin: 0 auto;
    border-radius: 2px;
}

a {
    text-decoration:none;
}

.el-form-item{
    margin-bottom: 16px;
}

.el-button {
    width: 100%;
    margin-top: 14px;
    border-radius: 20px;
    background: linear-gradient(to right, #2E9FFF, #3E79FF);
    box-shadow: 0 4px 10px rgba(0,123,255,.5)
}

.forget{
    font-size: 13px;
    color: #007bff;
    margin-top: 52px;
}

.foot-msg{
    color: #fff;
    font-size: 15px;
    width: 300px;
    text-align: center;
    margin-left: -150px;
    bottom: 15px;
    left: 50%;
}

.el-input >>> input {
    background-color: #F7F5FB;
    border-radius: 20px;
    padding-left: 20px;
    border: 0;
    color: #555555;
}

@media screen and (max-width:767px){
    .bg{
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        z-index: 0;
        height: 100%;
    }
    .login-item{
        height: 100%;
    }
    .login{
        height: 50%;
        width: 60%;
    }
    .logo-title{
        padding-top: 1rem;
        margin-bottom: 0.5rem;
    }
    .foot-msg{
        bottom: 1rem;
    }
}
</style>

<script>
import axios from '@/axios'

export default {
    data() {
        return {
            loading: false,
            captchaUrl: null,
            rules: {
                mobile: [
                    {required: true, message: '请填写手机号。'}
                ],
                password: [
                    {required: true, message: '请填写密码。'}
                ],
                captcha: [
                    {required: true, message: '请填写验证码。'}
                ]
            },
            form: {
                mobile: '',
                password: '',
                captcha: ''
            },
            res: ''
        }
    },
    created() {
        this.reloadCaptcha()
    },
    methods: {
        reloadCaptcha() {
            axios({
                url: 'site/captcha',
                params: {
                    refresh: 1
                }
            }).then(e => {
                this.captchaUrl = e.data.url
            }).catch(e => {
            })
        },
        submit(formName) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    this.loading = true
                    axios({
                        url: 'common/login',
                        method: 'post',
                        data: this.form
                    }).then(e => {
                        if (e.data.code === 0) {
                            this.$store.dispatch('setUser', e.data.data)
                            this.$router.push({
                                path: '/plugin/plugin'
                            })
                        } else {
                            this.loading = false
                            this.$message.error(e.data.msg)
                            this.reloadCaptcha()
                        }
                    })
                } else {
                }
            })
        }
    }
}
</script>
